export default __webpack_public_path__ + "static/media/ic-clock-in.f8978ea4.svg";